// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class EditView extends JQueryView {
  constructor() {
    super('.company.director_meetings.selected_attendees.edit');
    this.onChangeAllCheckbox();
  }

  @on({ event: 'change', selector: 'input[name="all_checked"]' })
  onChangeAllCheck() {
    console.log('alllcheck');
    const allChecked = $('input[name="all_checked"]').prop('checked');
    if (allChecked) {
      $('input[type=checkbox]').prop('checked', true);
    } else {
      $('input[type=checkbox]').prop('checked', false);
    }
  }

  @on({ event: 'change', selector: $('input[type=checkbox]') })
  onChangeAllCheckbox() {
    const selectedCount = $(
      'input:checkbox:checked[id^="officer_approval_director_meeting_officer_approval_user_companies_attributes_"]',
    ).length;
    const totalCount = $(
      'input:checkbox[id^="officer_approval_director_meeting_officer_approval_user_companies_attributes_"]',
    ).length;

    if (totalCount === selectedCount) {
      $('input[name="all_checked"]').prop('checked', true);
    } else {
      $('input[name="all_checked"]').prop('checked', false);
    }
  }
}
